<template>
    <div id="rulesModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog mt-0" role="document">
            <div class="modal-content container">
                <header class="page-header">
                    <div class="container">
                        <a href="javascript:;" data-dismiss="modal" class="logo d-none d-sm-block">
                            <img src="../assets/svg/logo.svg" alt="airBaltic">
                        </a>
                    </div>
                </header>

                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <svg width="42" height="42" viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg">
                            <g transform="translate(1 1)" stroke="#FFF" fill="none" fill-rule="evenodd">
                                <circle cx="20" cy="20" r="20"/>
                                <path d="M20 20.476l6.652-6.652L20 20.476l-6.972-6.972L20 20.476zm0 0l-6.278 6.279L20 20.476l6.496 6.496L20 20.476z"
                                      stroke-linecap="square"/>
                            </g>
                        </svg>
                    </button>
                </div>

                <div class="modal-body" v-html="content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RulesModal',

        data() {
            return {
                content: ''
            }
        },

        async created() {
            let response = await this.$api.getPages();

            response.data.items.forEach(page => {
                if (page.slug === 'rules') {
                    this.content = page.content.content;
                }
            });
        }
    }
</script>